import React from 'react';
import { Carousel } from 'react-responsive-carousel';
import PropTypes from 'prop-types';
import './MultipleItemsCarousel.scss';

const MultipleItemsCarousel = ({ itemsPerSwipe, items, selectedPage }) => {
  const newItem = (itemsToGroup, i, numberPerSwipe) => {
    const res = itemsToGroup.slice(i, i + numberPerSwipe);
    // if array has fewer items than expected, empty divs are added to keep style consistency
    if (res.length < numberPerSwipe) {
      const numberToBeAdded = numberPerSwipe - res.length;
      for (let z = 0; z < numberToBeAdded; z += 1) {
        res.push(
          <div
            key={`fake-item${z}`}
            className="multiple-items-carousel-hidden"
          />
        );
      }
    }
    return res;
  };

  const renderCarouselGroup = itemsToRender => {
    const resultsRender = [];

    for (let i = 0; i < itemsToRender.length; i += itemsPerSwipe) {
      resultsRender.push(
        <div key={`item-list${i}`} className="item-list__wrapper">
          {newItem(itemsToRender, i, itemsPerSwipe)}
        </div>
      );
    }
    return resultsRender;
  };

  return (
    <Carousel
      showThumbs={false}
      showArrows={false}
      selectedItem={selectedPage}
      showIndicators={false}
      showStatus={false}
      centerSlidePercentage={90}
      centerMode
      autoPlay={false}
    >
      {renderCarouselGroup(items)}
    </Carousel>
  );
};

MultipleItemsCarousel.propTypes = {
  itemsPerSwipe: PropTypes.number.isRequired,
  items: PropTypes.arrayOf(PropTypes.element).isRequired,
  selectedPage: PropTypes.number.isRequired
};

export default MultipleItemsCarousel;
